module.exports = __webpack_public_path__ + "img/orange_086.5f8f618b.png";